import { useEffect } from 'react';
import { faro } from '@grafana/faro-web-sdk';
import { initFaro } from './faro';

/***************************  GRAFANA FARO  ***************************/

export default function GrafanaFaro() {
  useEffect(() => {
    initFaro();

    // Send web vitals to Faro once initialized
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
      const report = ({ name, value, rating }: { name: string; value: number; rating: string }) => {
        try {
          faro.api.pushMeasurement({
            type: 'web-vitals',
            values: { [name]: value },
            context: { rating }
          });
        } catch {
          // faro not yet initialized
        }
      };

      onCLS(report);
      onFCP(report);
      onLCP(report);
      onTTFB(report);
      onINP(report);
    });
  }, []);

  return null;
}
